export const SIGNUP_CREATE_INIT = 'SIGNUP_CREATE_INIT';
export const SIGNUP_CREATE_ERROR = 'SIGNUP_CREATE_ERROR';
export const SIGNUP_CREATE_SUCCESS = 'SIGNUP_CREATE_SUCCESS';

export const SIGNUP_CONTINUE_INIT = 'SIGNUP_CONTINUE_INIT';
export const SIGNUP_CONTINUE_ERROR = 'SIGNUP_CONTINUE_ERROR';
export const SIGNUP_CONTINUE_SUCCESS = 'SIGNUP_CONTINUE_SUCCESS';
export const SIGNUP_CONTINUE_RESET = 'SIGNUP_CONTINUE_RESET';
